import type { DataRefId, OverreactRequestShape } from '../../public-types';
import type { RecordGroup } from '../record-group';
import { DataRef } from './data-ref';

export class DataNode {
  dataRefs: Record<string, DataRef>;

  constructor() {
    this.dataRefs = {};
    this.getDataRef = this.getDataRef.bind(this);
    this.dataRefIdsUpdate = this.dataRefIdsUpdate.bind(this);
    this.entitiesCreated = this.entitiesCreated.bind(this);
    this.entitiesDeleted = this.entitiesDeleted.bind(this);
  }

  getDataRef(key: DataRefId) {
    const normalizedKey = String(key);
    if (!this.dataRefs[normalizedKey]) {
      this.dataRefs[normalizedKey] = new DataRef(key);
    }
    return this.dataRefs[normalizedKey];
  }

  dataRefIdsUpdate(
    _recordGroup: RecordGroup,
    updatedIds: string[],
    request?: OverreactRequestShape,
  ) {
    Object.keys(this.dataRefs).forEach(key => this.dataRefs[key].onUpdate(updatedIds, request));
  }

  entitiesCreated(_recordGroup: RecordGroup, ids: string[]) {
    Object.keys(this.dataRefs).forEach(key => this.dataRefs[key].onEntitiesCreated(ids));
  }

  entitiesDeleted(_recordGroup: RecordGroup, ids: string[]) {
    Object.keys(this.dataRefs).forEach(key => this.dataRefs[key].onEntitiesDeleted(ids));
  }

  toJson() {
    return { dataRefs: Object.keys(this.dataRefs).map(key => this.dataRefs[key].toJson()) };
  }
}
